import type { ReactElement } from 'react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import { IMAGE } from '@ui-kit/assets/images/index.web'
import Icon from '@ui-kit/components/SvgIcon/index.web'
import Card from '@ui-kit/components/cards/Card/index.web'

import * as styles from './styles'
import type { WebProps } from './types'

const CallToActionCard = (props: WebProps): ReactElement => {
  const contentStyle = props.contentStyle || 'dark'
  const chevronSource =
    contentStyle === 'light'
      ? IMAGE.icons.small.action.chevronRightUiLight_24
      : IMAGE.icons.small.action.chevronRight_24

  const leftIcon = props.icon || null
  const showActionIcon = props.showActionIcon !== false
  const actionIcon = showActionIcon ? props.actionIcon || <Icon imgSrc={chevronSource} /> : null

  const { container, image, content, title, subtitle } = styles.callToActionCard({
    style: contentStyle,
  })

  return (
    <Card
      onClick={props.onClick}
      data-testid={props.testID}
      bgColor={props.bgColor}
      borderColor={props.borderColor ?? 'grey300'}
    >
      <div className={twMerge(container(), props.className)}>
        {leftIcon}
        {props.imageUrl ? <img className={image()} src={props.imageUrl} /> : null}
        <div className={content()}>
          <div className={title()}>{props.title}</div>
          {props.subtitle && <div className={subtitle()}>{props.subtitle}</div>}
        </div>
        {actionIcon}
      </div>
    </Card>
  )
}

export default CallToActionCard
